<script>
import {onMounted, ref, watch} from "vue";
import useTools from "@/use/Tools.js";
import axios from "axios";

export default {
    props: {
        value: [Object, Number, String, Boolean],
        label: String,
        trialPeriod: Boolean,
        disabled: Boolean,
    },
    name: "StrDurationAutocomplete",
    setup(props, {emit}) {
        const {$i18n} = useTools();
        const duration = ref(null);
        const durations = ref([]);
        const loading = ref(false);


        const generateRandomString = length => [...Array(length)].map(() => Math.random().toString(36)[2]).join('');

        function findAll() {
            loading.value = true;
            axios.get('/contratTemplates/groupDuration', {
                params: {
                    trialPeriod: props.trialPeriod
                }
            }).then(response => {
                response.data.forEach(element => {
                    durations.value.push({
                        ...element,
                        id: generateRandomString(10),
                        name: `${element.duration} ${$i18n.t('common.' + element.periodicity)}`
                    })
                });
            }).finally(() => {
                loading.value = false;
            });

        }

        watch(() => duration.value, () => {
            emit('input', duration.value);
        });

        onMounted(() => findAll());

        return {
            loading,
            duration,
            durations
        }
    },
}
</script>

<template>
    <div>
        <w-enum-select
            v-model="duration"
            :items="durations"
            :loading="loading"
            :disabled="disabled"
            :label="label"
            return-object
        />
        <input type="hidden"/>
    </div>
</template>